import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { requirePermission } from '@/shared/auth/guards'

const SETTINGS_TABS = ['terms', 'tenant'] as const

export type SettingsTab = (typeof SETTINGS_TABS)[number]

export const settingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings',
  beforeLoad: requirePermission('users.view'),
  validateSearch: (search) =>
    z.object({ tab: z.enum(SETTINGS_TABS).optional().catch(undefined) }).parse(search),
  component: lazyRouteComponent(() => import('./pages/settings-page'), 'SettingsPage'),
})
